//import { dispatch } from 'react-hot-toast/dist/core/store';
import approvalApi from '../apis/approvalsApi';
import axios from 'axios';

//test data

const archibusTestData = [
  {
    "createdDate": "2024-10-22",
    "recordsCount": 1,
    "email": "Beto.HernandezAdame@intusurg.com",
    "eM_ID": "BETO HERNANDEZ ADAME-658"
  },
  {
    "createdDate": "2024-10-17",
    "recordsCount": 1,
    "email": "Beto.HernandezAdame@intusurg.com",
    "eM_ID": "DAMIEN SWIRBLE-066"
  },
  {
    "createdDate": "2024-10-17",
    "recordsCount": 1,
    "email": "Beto.HernandezAdame@intusurg.com",
    "eM_ID": "DAMIEN SWIRBLE-066"
  }
];


//  {
//           "documentType": "PurchaseOrder",
//           "docNumber": "4500255883",
//           "taskId": "TS00800531",
//           "requester": "NANCYR",
//           "responsible": null,
//           "delegatedTo": null,
//           "createdOn": "20241203",
//           "description": "Approve Purchase Order 4500255882 (updated 3)",
//           "taskStatus": "READY",
//           "pastDueDays": null,
//           "appType": null,
//           "link": "https://ecq.intusurg.com:/sap/bc/ui2/flp#WorkflowTask-displayInbox?standaloneDetailDeep=true&/detail_deep/LOCAL_TGW/000045652631/TaskCollection(SAP__Origin='LOCAL_TGW',InstanceID='000045652631')"
//         }

const sapWfTestData =
{
  "Count": 0,
  "AppName": "SAPWORKFLOW",
  "ApprovalItems": [
    {
      "purchaseOrder": [],
      "changeRecord": []
    }
  ]
};

const workforceTestData = [
  {
    "requestor": "Eghbal, Darius",
    "employeeId": "514978",
    "timeOffType": "Flex Vacation",
    "timeOffDate": "2025-01-02T00:00:00",
    "startTime": "",
    "endTime": "",
    "value": 8.00,
    "unit": "Hours",
    "status": "Pending",
    "createdDate": "2024-12-10"
  },
  {
    "requestor": "Eghbal, Darius",
    "employeeId": "514978",
    "timeOffType": "Flex Vacation",
    "timeOffDate": "2025-01-03T00:00:00",
    "startTime": "",
    "endTime": "",
    "value": 8.00,
    "unit": "Hours",
    "status": "Pending",
    "createdDate": "2024-12-10"
  },
  {
    "requestor": "Garibaldi, Mark",
    "employeeId": "516085",
    "timeOffType": "Flex Vacation",
    "timeOffDate": "2025-01-02T00:00:00",
    "startTime": "",
    "endTime": "",
    "value": 8.00,
    "unit": "Hours",
    "status": "Pending",
    "createdDate": "2024-12-26"
  },
  {
    "requestor": "Garibaldi, Mark",
    "employeeId": "516085",
    "timeOffType": "Flex Vacation",
    "timeOffDate": "2025-01-03T00:00:00",
    "startTime": "",
    "endTime": "",
    "value": 8.00,
    "unit": "Hours",
    "status": "Pending",
    "createdDate": "2024-12-26"
  }
];




//Action Creator
export const selectSystem = (system) => {
  //return an action
  return {
    type: 'SYSTEM_SELECTED',
    payload: system
  };
};

export const selectDayFilter = (filter) => {
  return {
    type: 'DAY_FILTER_SELECTED',
    payload: filter
  }
}

export const taskCleared = (taskCleared) => {
  //console.log("I am in action taskCleared removing: ", taskCleared);
  return {
    type: 'TASK_CLEARED',
    payload: taskCleared
  }
}

export const updatePreviousSystemCounts = (curSystemCounts) => {

  // console.log("I AM IN ACTIONS: ", curSystemCounts);
  return {
    type: 'UPDATE_PREVIOUS_COUNTS',
    payload: curSystemCounts
  }
}

export const approveTask = (taskApproved, authObj) => async dispatch => {
  // console.log("I am in action taskApproved approving: ", taskApproved.id, authObj);

  const body = {
    id: taskApproved.id,
    state: 'approved'
  };
  try {
    const response = await approvalApi.post("/HelpNow/ApprovalAction", body, {
      headers: {
        Authorization: `Bearer ${authObj}`,
      }
    });
    // console.log(response.data);
  } catch (err) {
    // console.log("HelpNow Approval API error, failed to approve. ", err);
  }

  dispatch({ type: 'TASK_CLEARED', payload: taskApproved });
}

export const rejectTask = (taskRejected, authObj) => async dispatch => {
  // console.log("I am in action taskRejected rejecting: ", taskRejected);

  const body = {
    id: taskRejected.id,
    state: 'rejected'
  };
  try {
    const response = await approvalApi.post("/HelpNow/ApprovalAction", body, {
      headers: {
        Authorization: `Bearer ${authObj}`,
      }
    });
    // console.log(response.data);
  } catch (err) {
    // console.log("HelpNow Approval API error, failed to reject. ", err);
  }

  dispatch({ type: 'TASK_CLEARED', payload: taskRejected });
}

export const fetchApprovals = (authObj) => async dispatch => {

  dispatch({ type: 'FETCH_SENT' }); //started fetch used for loading screen
  //return an action
  console.log(`Okta response details: ${JSON.stringify(authObj)}`); //token to be sent to API
  // console.log(`My Token: ${this.props.authState.accessToken}`);

  //let testData = JSON.parse(fs.readFileSync("testData.json", "utf8"));
  //console.log(testData);

  let myObj = authObj;

  //Empty data arrays
  let curIsuData = [];
  //let curAribaData = [];
  let curAgileData = [];
  let curSapQnData = [];
  let curCoupaData = [];
  let curSamData = [];
  let curSnowData = [];
  let curApprovals = [];
  let curTrackwiseData = [];
  let curIvaluaData = [];
  let curItTimesheetData = [];
  let curConcurData = [];
  let curNeptuneData = []; //MT
  let curFieldglassData = [];
  let curSmartrecruitersData = [];
  let curNeptunePsData = [];
  let curMyHcmData = [];
  let curMesData = [];
  let curAdobeSignData = [];
  let curArchibusData = [];
  let curWorkdayData = [];
  let curSapWfData = {};
  let curWorkforceData = {};
  let curArchibusMaintenanceData = {};

  //  if(process.env.REACT_APP_ENVIRONMENT === "local") {
  //    curIsuData = isuTestData;
  //    curAribaData = aribaTestData;
  //    curAgileData = agileTestData;
  //  }


  //const testToken = "eyJraWQiOiJOd3FMSDR2OWNkdlpXNFJqQTZndkhULVNFcUFpWUVLOUZ5cklrVWxlUE1jIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULlhPbGNaaHFZeGJYNU51ZmU1aGdGVWwwTndYYXlFZ0tOWG15TXVrUjZMT0UiLCJpc3MiOiJodHRwczovL2lzcmd0ZXN0Lm9rdGEuY29tL29hdXRoMi9kZWZhdWx0IiwiYXVkIjoiYXBpOi8vZGVmYXVsdCIsImlhdCI6MTYxMzQyNTAyMSwiZXhwIjoxNjEzNDI4NjIxLCJjaWQiOiIwb2ExaWZibXFpb09vQUNLazFkOCIsInVpZCI6IjAwdTFmZHF3eTlzTVdHWEE3MWQ4Iiwic2NwIjpbIm9wZW5pZCIsImVtYWlsIiwicHJvZmlsZSJdLCJzdWIiOiJCSGVybmFuZGV6QGlzcmd0ZXN0LmNvbSJ9.aCY_XARoEAU9wGVUr0kbR-56-8f7y12nPIbtBX9Jazy6wGy-nNvr6TVB6tDtwnDWPrnqL8aFPIxvrlLs09rT7E6t01JkpQVHyJJBMb7Ang5qswvnDRcCn8WfIplXLkr_79SESt4AeaqATfERujlZQ7EeybhNgU6mIoov8vL-g6LzfCV2GUdqE94ng7Xuqkfr-p1VrMrLMF8zujrnn3_pQE8P_cDr_z9UYNI1paszkBLGA9PcHqZk5f1KGMC13MOOZsEUksbHeH32uKXyqA7LGjiT_8Z5oq-9l6Gsodj6AsABtfTAcGt0izf8dkH--i8XEuDAybfBAE0ftCGqLMNu7Q";
  if (process.env.REACT_APP_ENVIRONMENT === "local"
    || process.env.REACT_APP_ENVIRONMENT === "dev"
    || process.env.REACT_APP_ENVIRONMENT === "uat"
    || process.env.REACT_APP_ENVIRONMENT === "prod") {

    //ISU  API call
    try {
      const response = await approvalApi.get("/ISU/MyLearning/", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curIsuData = response.data;
      // console.log("ISU payload:", curIsuData);
    } catch (err) {
      console.log("ISU API error, failed to get ISU records. ", err);
    }
    //console.log("---------Api  Data --------");
    //console.log("Api Data", response.data); 
    //myObj.approvals = response.data;

    //Agile API call
    try {
      const response2 = await approvalApi.get("/Agile/PendingApprovals/", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curAgileData = response2.data;
      // console.log("Agile payload:", curAgileData);
    } catch (err) {
      console.log("Agile API error, failed to get Agile records. ", err);
    }

    //SAP QN API call
    try {
      const response4 = await approvalApi.get("/SAPQN/PendingNotifications", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curSapQnData = response4.data;
      // console.log("SAP payload:", curSapQnData);
      //curSapQnData = sapQnTestData;
    } catch (err) {
      console.log("SAP QN API error, failed to get SAP QN records. ", err);
    }

    //Coupa call
    try {
      const response5 = await approvalApi.get("/Coupa/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curCoupaData = response5.data;
      // console.log("Coupa payload:", curCoupaData);
    } catch (err) {
      console.log("COUPA API error, failed to get COUPA records. ", err);
    };

    //SAM
    try {
      const response6 = await approvalApi.get("/SAM/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curSamData = response6.data;
      //curSamData = samTestData;
      // console.log("SAM payload:", curSamData);
    } catch (err) {
      console.log("SAM API error, failed to get SAM records. ", err);
    }

    //SNOW
    try {
      const response7 = await approvalApi.get("/HelpNow/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curSnowData = response7.data;
      // console.log("SNOW payload:", curSnowData);
    } catch (err) {
      console.log("SNOW API error, failed to get SNOW records. ", err);
    }

    //trackwise
    try {
      const response8 = await approvalApi.get("/Trackwise/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curTrackwiseData = response8.data;
      // console.log("Trackwise payload:", curTrackwiseData);
    } catch (err) {
      console.log("Trackwise API error, failed to get Trackwise records. ", err);
    }

    //iValua API Call
    try {
      const response9 = await approvalApi.get("/IValua/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curIvaluaData = response9.data;
      //curIvaluaData = ivaluaTestDataa;
      // console.log("Ivalua payload:", curIvaluaData);
    } catch (err) {
      console.log("Trackwise API error, failed to get Trackwise records. ", err);
    }

    //IT Timesheet API call
    try {
      const response10 = await approvalApi.get("/ITTimeSheet/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curItTimesheetData = response10.data;
      // console.log("IT Timesheet payload:", curItTimesheetData);
    } catch (err) {
      console.log("IT Timesheet API error, failed to get IT Timesheet records. ", err);
    }

    //Concur API call
    try {
      const response11 = await approvalApi.get("/concur/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curConcurData = response11.data;
      //curConcurData =  concurTestData;
      // console.log("Concur payload:", curConcurData);
    } catch (err) {
      console.log("Concur API error, failed to get Concur records. ", err);
    }

    //
    //call Neptune MT API
    try {
      const response12 = await approvalApi.get("/NeptuneMT/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curNeptuneData = response12.data;
      //curNeptuneData = []; 
      //curNeptuneData = neptuneTestData;
      // console.log("Neptune MT payload:", curNeptuneData);
    } catch (err) {
      console.log("Neptune API error, failed to get Neptune records. ", err);
      //curNeptuneData = neptuneTestData;
    }


    //call Fieldglass API
    try {
      const response13 = await approvalApi.get("/FieldGlass/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      // console.log("API FG Response: ", response13.data);
      curFieldglassData = response13.data;
      //curFieldglassData = fieldglassTestData;
      // console.log("Fieldglass payload:", curFieldglassData);
    } catch (err) {
      console.log("Fieldglass API error, failed to get fieldglass records. ", err);
    }

    //call SmartRecruiters API
    try {
      const response14 = await approvalApi.get("/SmartRecruiters/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      // console.log("API SmartRecruiters Response: ", response14.data);
      curSmartrecruitersData = response14.data;
      //curSmartRecruitersData = smartrecruitersTestData;
      // console.log("SmartRecruiters payload:", curSmartrecruitersData);
    } catch (err) {
      console.log("SmartRecruiters API error, failed to get SmartRecruiters records. ", err);
    }

    //call Neptune PS API
    try {
      const response15 = await approvalApi.get("/NeptunePS/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curNeptunePsData = response15.data;
      //curNeptunePsData = [];
      //curNeptuneData = neptuneTestData;
      // console.log("Neptune PS payload:", curNeptuneData);
    } catch (err) {
      console.log("Neptune PS API error, failed to get Neptune records. ", err);
      //curNeptuneData = neptuneTestData;
    }

    //call My HCM API
    try {
      const response16 = await approvalApi.get("/MyHcm/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curMyHcmData = response16.data;
      // console.log("My HCM payload:", curMyHcmData);
    } catch (err) {
      console.log("My HCM  API error, failed to get My HCM records. ", err);
    }

    //call MES API
    try {
      const response17 = await approvalApi.get("/MES/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curMesData = response17.data;
      // console.log("MES payload:", curMesData);
    } catch (err) {
      console.log("MES API error, failed to get MES records. ", err);
    }

    //call Adobe Sign
    try {
      const response18 = await approvalApi.get("/Adobe/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curAdobeSignData = response18.data;
      // if (process.env.REACT_APP_ENVIRONMENT === "local") {
      //   curAdobeSignData = adobeSignTestData;
      // }
      // console.log("Adobe Sign Payload: ", curAdobeSignData);

      //console.log("Adobe Sign payload:", curAdobeSignData);
    } catch (err) {
      console.log("Adobe Sign API error, failed to get Adobe Sign records. ", err);
    }


    //call Archibus API
    try {
      const response19 = await approvalApi.get("/archibus/pendingapprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curArchibusData = response19.data;
      // if (process.env.REACT_APP_ENVIRONMENT === "local") {
      //   curArchibusData = archibusTestData;
      // }
      // console.log("Archibus Payload: ", curArchibusData);

      // console.log("Archibus payload:", curArchibusData);
    } catch (err) {
      console.log("Archibus API error, failed to get Archibus records. ", err);
    }

    //call Workday API
    try {
      const response20 = await approvalApi.get("/workday/pendingapprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });

      curWorkdayData = response20.data;
      // if (process.env.REACT_APP_ENVIRONMENT === "local") {
      //   curWorkdayData = workdayTestData;
      // }
      //console.log("Workday Payload: ", curWorkdayData);

      //console.log("Workday payload:", curWorkdayData);
    } catch (err) {
      console.log("Workday API error, failed to get Workday records, setting to empty array. ", err);
      curWorkdayData = [];
    }

    //call SAP Workflows API
    try {
      const response21 = await approvalApi.get("/sapworkflow/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curSapWfData = response21.data;
      //curSapWfData.changeRecord = [];
      // if (process.env.REACT_APP_ENVIRONMENT === "local") {
      //   curSapWfData = sapWfTestData.ApprovalItems[0];
      // }
      console.log("SAP WF Payload: ", curSapWfData);

      //console.log("SAP WF payload:", curSapWfData);
    } catch (err) {
      console.log("SAP WF API error, failed to get SAP Workflows API records. ", err);

      curSapWfData.purchaseOrder = [];
      //curSapWfData = sapWfTestData.ApprovalItems[0];
      curSapWfData.changeRecord = []; //empty all the time for now until prod move is ready
      console.log("SAP WF Payload: ", curSapWfData);
    }

    //call Workforce API
    try {
      const response22 = await approvalApi.get("/Workforce/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curWorkforceData = response22.data;
    } catch (err) {
      console.log("Workforce API error, failed to get workforce API records. ", err);

      curWorkforceData = [];
    }

    //call Archibus Maint. API
    try {
      const response23 = await approvalApi.get("/ArchibusMaintenance/PendingApprovals", {
        headers: {
          Authorization: `Bearer ${authObj.token.accessToken}`,
        },
      });
      curArchibusMaintenanceData = response23.data;
      // if (process.env.REACT_APP_ENVIRONMENT === "local") {
      //   curArchibusData = archibusTestData;
      // }
      // console.log("Archibus Payload: ", curArchibusData);

      // console.log("Archibus payload:", curArchibusData);
    } catch (err) {
      console.log("Archibus Maintenance API error, failed to get Archibus records. ", err);
    }

  };


  //loop through ISU Data & Massage
  let key_counter = 1;
  for (let x of curIsuData) {
    x.id = x.sku + key_counter;
    key_counter++;
    //console.log("Counter Test: ", x.id);
    x.approvalRequester = null;
    x.assignedDate = x.assignedDate.substring(0, 10);
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "isu";
    x.link = "https://intusurg.okta.com/home/bookmark/0oa1rc53x3p8DQgqh1d8/2557"; //prod
    curApprovals.push(x);
  }


  //console.log("USING NEW SMART LINK FOR AGILE");
  //loop through Agile Data & Massage
  key_counter = 1;
  for (let x of curAgileData) {
    x.id = x.id + key_counter; //make id unique just incase
    key_counter++;
    x.title = x.changeNumber;
    x.approvalRequester = x.changeOriginator;
    x.assignedDate = x.createdDateTime.substring(0, 10);

    //console.log("TEST Agile DATE FORMAT :", x.assignedDate);
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.changeDescription;
    x.systemName = "agile";
    x.link = `https://aglp.intusurg.com/Agile/object/${x.changeType}/${x.changeNumber}` //smart link 
    curApprovals.push(x);
  };

  key_counter = 1;
  //loop through SAP QN Data & Massage
  for (let x of curSapQnData) {
    let newNotification = x.notification.replace(/^0+/, ''); //remove leading zeros
    x.id = x.notification + key_counter; //make id unique just incase
    key_counter++;
    x.title = newNotification;
    x.approvalRequester = x.createdBy;
    //new date formatting
    //let newDate = [x.createdOn.slice(0,4), "-", x.createdOn.slice(4)].joing('');
    x.assignedDate = x.createdOn.substring(0, 4) + "-" + x.createdOn.substring(4, 6) + "-" + x.createdOn.substring(6);
    //console.log("TEST: ", newDate);
    //x.assignedDate = newData.substring(0,10);
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.description;
    if (x.description == "N/A") {
      x.description = "";
    }
    x.systemName = "sap qn";

    if (x.link.includes("https")) {
      //if object includes a link
      // x.link = x.link;
    } else {
      //if no link is provided default to this one
      x.link = `https://prd.intusurg.com/sap/bc/gui/sap/its/webgui`;
    }
    curApprovals.push(x);
  };


  //loop through COUPA Data & Massage
  key_counter = 1;
  for (let x of curCoupaData) {
    //let newNotification = x.notification.replace(/^0+/,''); //remove leading zeros
    x.id = x.id + key_counter; //make id unique just incase
    key_counter++;
    x.title = x.documentType;
    x.approvalRequester = x.requestorDisplayName;
    //new date formatting
    //let newDate = [x.createdOn.slice(0,4), "-", x.createdOn.slice(4)].joing('');
    x.assignedDate = x.createdDateTime.substring(0, 10);
    //x.assignedDate = newData.substring(0,10);
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.totalAmount + " " + x.currency;
    x.systemName = "coupa";

    if (x.documentType === "Invoice") {
      x.link = "https://intuitive.coupahost.com/invoices/" + x.id;
      //x.link = `https://intuitive-test.coupahost.com`; // placeholder
      // console.log("added invoice deeplink");
    } else if (x.documentType === "Requisition") {
      x.link = "https://intuitive.coupahost.com/requisition_headers/" + x.id;
      //x.link = `https://intuitive-test.coupahost.com`; //placeholder
      // console.log("added requisition deeplink");
    } else {
      x.link = `https://intuitive.coupahost.com`; //no deeplink
      console.log("added base app link to coupa");
    }
    // x.link = "https://intuitive-dev.coupahost.com/invoices/" + x.id;
    //x.link = "https://intuitive-dev.coupahost.com/requisition_headers/" + x.id;
    //x.link = `https://intuitive-test.coupahost.com`; //no URL 
    curApprovals.push(x);
  };

  //loop through SAM Data & Massage
  key_counter = 1;
  for (let x of curSamData) {
    //let newNotification = x.notification.replace(/^0+/,''); //remove leading zeros
    x.id = x.id + key_counter; //make id unique just incase
    key_counter++;
    x.title = x.description;
    // if(x.applicationName){
    //   x.title = "Target System: " + x.applicationName;
    // } else {
    //   x.title = "Target System: N/A";
    // }

    let curEntitlement = "";
    let curApplication = "";
    let entitlementArr = [];
    let applicationArr = [];

    if (x.approvals) {
      let eCounter = 1000;
      let aCounter = 2000;
      for (const i of x.approvals) {
        if (i.displayValue) {
          let curObj = {
            name: i.displayValue,
            myKey: eCounter
          };
          entitlementArr.push(curObj);
          eCounter++;
          // if(eCounter == 0){
          //   curEntitlement = "Entitlement: " + i.displayValue;
          //   eCounter++;
          // } else {
          //   curEntitlement = curEntitlement + ", " + i.displayValue;
          // }
        }

        if (i.applicationName) {
          let curObj = {
            name: i.applicationName,
            myKey: aCounter
          };
          applicationArr.push(curObj);
          aCounter++;
          //applicationArr.push("Active Directory");
          // if(aCounter == 0){
          //   curApplication = "Application: " + i.applicationName;
          //   aCounter++;
          // } else {
          //   curApplication = curApplication + ", " + i.applicationName;
          // }
        }
      }
    } else {
      // curEntitlement = "";
      // curApplication = "";
      //x.description = "";
    }

    //console.log("CUR ENTITLEMENT:", curEntitlement );
    x.entitlementArr = [...new Set(entitlementArr)];
    //console.log("BEFORE ARR: ", applicationArr);
    let finalAppArr = [...new Set(applicationArr)];
    //console.log("AFTER ARR: ", finalAppArr);
    x.finalAppArr = finalAppArr;

    x.entitlement = curEntitlement;
    x.description = curApplication;

    if (x.requestorDisplayName) {
      x.approvalRequester = "Requested by: " + x.requestorDisplayName;
    } else {
      x.approvalRequester = "";

    }

    // if(x.displayValue){
    //   x.entitlement = "Entitlement: " + x.displayValue;
    // } else {
    //   x.entitlement = "";
    // }

    //x.entitlement = x.displayName;
    //new date formatting
    //let newDate = [x.createdOn.slice(0,4), "-", x.createdOn.slice(4)].joing('');
    //x.assignedDate = x.assignedDateTime.substring(0,10);
    let newDate = new Date(x.createdDateTime);
    let curMonth = newDate.getMonth() + 1; //add one since count starts at 0
    newDate = newDate.getFullYear() + "-" + curMonth + "-" + newDate.getDate();
    // console.log("SAM DATE: ", newDate);
    x.assignedDate = newDate;  //Thu Jun 24 04:46:50 PDT 2021

    //x.assignedDate = newData.substring(0,10);
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    // if(x.applicationName){
    //   x.description = "Application: " + x.applicationName;
    // } else {
    //   x.description = "";
    // }
    x.systemName = "sam";
    x.link = x.url; //no URL 
    curApprovals.push(x);
  };

  //loop through SNOW RCE Data & Message
  key_counter = 1;
  for (let x of curSnowData.rceHelpNowApprovals) {
    //for(let x of snowTestData2.rceHelpNowApprovals){
    x.id = x.sysId; //make id unique just incase
    key_counter++;
    x.title = x.taskNumber;
    x.approvalRequester = x.createdBy;
    x.assignedDate = x.createdOn.substring(0, 10);
    x.assignedDate = new Date(x.assignedDate).toLocaleDateString('fr-CA');
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.shortDescription;
    x.systemName = "rce servicenow";
    //x.link = `https://intusurg.okta.com/home/servicenow_app2/0oa17qza1s9pwlcwK1d8/14155`; 
    // x.link = ' https://intusurg.service-now.com/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId; //prod
    //x.link = ' https://intusurgtest.service-now.com/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId; //uat
    // x.link = ' https://intusurgdev.service-now.com/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId; //dev
    // x.link = process.env.REACT_APP_SNOW_LINK + x.sysId;
    x.link = process.env.REACT_APP_SNOW_LINK + '/it_sp?id=rce_approval_form&table=sysapproval_approver&sys_id=' + x.sysId + '%20&glide_sso_id%20=4287b3fb139d6e00d1fcbb176144b04f';
    // x.link = 'https://intusurgdev.service-now.com/it_sp?id=rce_approval_form&table=sysapproval_approver&sys_id='+ x.sysId +'%20&glide_sso_id%20=4287b3fb139d6e00d1fcbb176144b04f';
    curApprovals.push(x);
  };

  //loop through SNOW Regular Data & Message
  key_counter = 1;
  for (let x of curSnowData.helpNowApprovals) {
    x.id = x.sysId; //make id unique just incase
    key_counter++;
    x.title = x.taskNumber;
    x.approvalRequester = x.createdBy;
    x.assignedDate = x.createdOn.substring(0, 10);
    x.assignedDate = new Date(x.assignedDate).toLocaleDateString('fr-CA');
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.shortDescription;
    x.systemName = "helpnow";
    //x.link = `https://intusurg.okta.com/home/servicenow_app2/0oa17qza1s9pwlcwK1d8/14155`; 
    // x.link = ' https://intusurg.service-now.com/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId; //prod
    //x.link = ' https://intusurgtest.service-now.com/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId; //uat
    //x.link = ' https://intusurgdev.service-now.com/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId; //dev
    x.link = process.env.REACT_APP_SNOW_LINK + '/it_sp?id=approval&table=sysapproval_approver&sys_id=' + x.sysId;
    curApprovals.push(x);
  };

  //loop through Trackwise Data & Massage
  key_counter = 1;
  //console.log("Trackwise: ", curTrackwiseData);
  for (let x of curTrackwiseData) {
    //let newNotification = x.notification.replace(/^0+/,''); //remove leading zeros
    x.id = x.recordId + key_counter; //make id unique just incase
    key_counter++;
    x.title = x.recordId + " - " + x.recordType;
    x.approvalRequester = x.email;
    //new date formatting
    //let newDate = [x.createdOn.slice(0,4), "-", x.createdOn.slice(4)].joing('');
    //x.assignedDate = x.createdDateTime.substring(0,10);
    x.assignedDate = x.createdDate.substring(0, 10); //2021-09-09 13:54:00.0
    //x.assignedDate = newData.substring(0,10);
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.status;
    x.systemName = "trackwise";
    let deepLink = "https://trackwise.intusurg.com/TRW-PRD/Gateway.html?" + x.recordId;
    x.link = deepLink; //no URL 
    curApprovals.push(x);
  };

  //loop through iValua Data & Massage
  key_counter = 1;
  //console.log("iValua: ", curIvaluaData);
  for (let x of curIvaluaData) {
    //let newNotification = x.notification.replace(/^0+/,''); //remove leading zeros
    x.id = x.objectId + key_counter; //make id unique just incase
    key_counter++;
    x.title = x.workflowName;
    x.approvalRequester = "";
    //new date formatting
    //let newDate = [x.createdOn.slice(0,4), "-", x.createdOn.slice(4)].joing('');
    //x.assignedDate = x.createdDateTime.substring(0,10);
    x.assignedDate = x.assignedDate.substring(0, 10); //2021-09-09 13:54:00.0
    //x.assignedDate = newData.substring(0,10);
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.activityCode;
    x.delegation = x.delegation;
    x.systemName = "ivalua";
    let deepLink = "https://trackwise.intusurg.com/TRW-PRD/Gateway.html?" + x.recordId;
    x.link = x.fullUrl;
    curApprovals.push(x);
  };

  //loop through IT Timesheet
  key_counter = 1;
  for (let x of curItTimesheetData) {
    //let newNotification = x.notification.replace(/^0+/,''); //remove leading zeros
    x.id = "timesheet" + x.id + key_counter; //make id unique just incase
    key_counter++;
    x.title = x.projectName;
    x.approvalRequester = `${x.employeeFN} ${x.employeeLN}`;
    //new date formatting
    //let newDate = [x.createdOn.slice(0,4), "-", x.createdOn.slice(4)].joing('');
    //x.assignedDate = x.createdDateTime.substring(0,10);
    x.assignedDate = x.startDate.substring(0, 10); //2021-09-0913:54:00.0
    //x.assignedDate = newData.substring(0,10);
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    // eslint-disable-next-line
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = ` ${x.approvalRequester} Total Hours: ${x.totalHours}`;
    x.systemName = "it timesheet";
    //let deepLink = "https://itapps.corp.intusurg.com:8443/ISITMSystem/isrg.jsp?logout=true"; //no deeplink
    x.link = "https://itapps.corp.intusurg.com:8443/ISITMSystem/isrg.jsp?logout=true";
    curApprovals.push(x);
  };

  //loop through Concur
  key_counter = 1;
  for (let x of curConcurData) {
    x.id = "concur" + key_counter; //make id unique just incase
    key_counter++;

    if (x.reportName == null) {
      x.title = `Pending approval - Total: ${x.total} ${x.currencyCode}`;
    } else {
      x.title = `${x.reportName} - Total: ${x.total} ${x.currencyCode}`;
    }
    x.approvalRequester = x.requestorName;

    //("TEST: ", x.CreatedDate);
    if (x.createdDate == null) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      x.assignedDate = `${year}-${month}-${day}`;
    } else {
      x.assignedDate = x.createdDate.substring(0, 10); //2023-05-30T15:18:07.383
    }
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.description = x.comment;
    x.systemName = "concur";

    //x.link = x.reportLink; 
    x.link = "https://intusurg.okta.com/home/intusurg_sapconcur_1/0oa1iugbusySHm9qV1d8/aln1iugmpswWdhKR21d8";
    curApprovals.push(x);
  };

  //loop through Neptune MT
  key_counter = 1;
  for (let x of curNeptuneData) {
    x.id = x.mtNumber + key_counter; //make id unique just incase
    key_counter++;
    if (x.appType == "1") {
      x.title = `Approver View - ${x.mtNumber}`;
    }
    else if (x.appType == "2") {
      x.title = `Material Handler view - ${x.mtNumber}`;
    }
    else {
      x.title = `Approval - ${x.mtNumber}`;
    }

    x.approvalRequester = x.requestor;

    x.assignedDate = x.submissionDate.substring(0, 10); //2023-05-30T15:18:07.383
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "neptune mt";
    x.description = `Type:  ${x.requestType}  Requestor: ${x.requestor}`;

    //x.link = x.reportLink; 
    if (x.link.includes("https")) {
      // x.link = x.link;
    } else {
      //if no link is provided default to this one
      x.link = "https://prd.intusurg.com/neptune/webapp/?sap-client=800&launchpad=INTUITIVEWEBAPPS#WF-Approve";;
    }
    // if (x.link)
    //   x.link = x.link;
    curApprovals.push(x);
  }

  //loop through Neptune PS
  key_counter = 1;
  for (let x of curNeptunePsData) {
    x.id = "NeptunePs" + key_counter; //make id unique just incase
    key_counter++;
    x.title = `${x.processID} - Requested By: ${x.requestedBy}`;
    x.approvalRequester = x.requestedBy;

    x.assignedDate = x.createdOn.substring(0, 10); //2023-06-29T00:00:00
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "neptune ps";
    x.description = x.description;

    //x.link = x.reportLink; 

    if (x.link.includes("https")) {
      //if object includes a link
      // x.link = x.link;
    } else {
      //if no link is provided default to this one
      x.link = "https://prd.intusurg.com/neptune/webapp/?launchpad=INTUITIVEWEBAPPS";
    }
    curApprovals.push(x);
  }

  //loop through Fieldglass

  let updatedTimeTmp1 = new Date(); // API doesn't currently have this
  let updatedTimeTmp2 = new Date(Date.parse(updatedTimeTmp1));
  updatedTimeTmp2 = updatedTimeTmp2.toString();
  let updatedTimeFinal = updatedTimeTmp2.replace(/GMT.*/g, "");

  key_counter = 1;
  //console.log("TesT: ", curFieldglassData);
  if (curFieldglassData.timeSheets.length > 0) {
    console.log("Timesheets exist")
    for (let x of curFieldglassData.timeSheets) {
      x.id = x.documentID + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.workerName;

      x.title = `Time sheet - ${x.documentID} - ${x.workerName}`;

      //formart date to year-month-day
      let parts = x.startDate.split("/");
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = x.costAllocation;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      // console.log("Final FG Timesheet: ", x)
      curApprovals.push(x);
    }
  }

  key_counter = 1;
  if (curFieldglassData.expenseSheets.length > 0) {
    // console.log("expens sheets exist")
    for (let x of curFieldglassData.expenseSheets) {
      x.id = "timeSheet" + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.workerName;

      x.title = `Expense Sheet - ${x.mainDocumentTitle}`;
      //formart date to year-month-day
      x.submittedDate = x.submittedDate.substring(0, 10); // 05/22/2023 07:51 AM
      let parts = x.submittedDate.split("/");
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = `Amount: ${x.expenseSheetAmount}`;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      // console.log("Final FG Expense Sheets: ", x)
      curApprovals.push(x);
    }
  }

  key_counter = 1;
  if (curFieldglassData.miscInvoices.length > 0) {
    // console.log("miscInvoices exist");
    for (let x of curFieldglassData.miscInvoices) {
      x.id = "miscinvoices" + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.workerName;

      x.title = `Invoice - ${x.mainDocumentTitle} - ${x.workerName}`;

      //formart date to year-month-day
      let parts = x.submittedDate.split("/");
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = `Supplier: ${x.supplier} - Amount:  ${x.amount}`;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      // console.log("Final FG Invoice: ", x)
      curApprovals.push(x);
    }

    // {
    //   "supplier": "Synergy Services dba. TalentWave",
    //   "submittedDate": "06/27/2023",
    //   "workerName": "Castro, David",
    //   "businessUnit": "Manufacturing Systems",
    //   "site": "3420 Central Expressway, Santa Clara 95051",
    //   "mainDocumentTitle": "AFQI Technician (Payrolled)",
    //   "amount": "305.43",
    //   "link": "https://xuat.fgvms.com/misc_invoice_detail.do?id=z2306271815383366784590e&ticc=ISI"
    // }
  }
  if (curFieldglassData.jobPostings.length > 0) {
    // console.log("Job Postings exist")
    for (let x of curFieldglassData.jobPostings) {
      x.id = "jobposting" + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.creatorName;

      x.title = `Job Posting - ${x.refId} - ${x.jobPostingTitle}`;

      //formart date to year-month-day
      let parts = x.createdDate.split("/");
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = x.jobPostingJustification;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      // console.log("Final FG Job Posting: ", x)
      curApprovals.push(x);
    }
  }

  //Fieldglass Phase 2 
  if (curFieldglassData.jobPostings.length > 0) {
    // console.log("Job Postings exist")
    for (let x of curFieldglassData.jobPostings) {
      x.id = "jobposting" + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.creatorName;

      x.title = `Job Posting - ${x.refId} - ${x.jobPostingTitle}`;

      //formart date to year-month-day
      let parts = x.createdDate.split("/");
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = x.jobPostingJustification;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      // console.log("Final FG Job Posting: ", x)
      curApprovals.push(x);
    }
  }
  //Fieldglass Phase 2
  if (curFieldglassData.workOrders.length > 0) {
    // console.log("Work Orders exist")
    for (let x of curFieldglassData.workOrders) {
      x.id = "workOrders" + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.jobSeeker;

      x.title = `Work Order - ${x.refId} - ${x.jobSeeker} - ${x.mainDocumentTitle}`;

      //formart date to year-month-day
      let parts = x.startDate.split("/"); // 07/10/2023
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = `Site: ${x.location}, Unit: ${x.businessUnit}, Amount: ${x.amount}`;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      //x.link = "https://xuat.fgvms.com/work_order_detail.do?id=z23092715584684443872903&ticc=ISI";
      //xconsole.log("Final FG Work Order: ", x)
      curApprovals.push(x);
    }
  }

  if (curFieldglassData.workOrderRevision.length > 0) {
    console.log("Work Orders exist")
    for (let x of curFieldglassData.workOrderRevision) {
      x.id = "workOrderRevision" + key_counter; //make id unique just incase
      key_counter++;
      x.approvalRequester = x.jobSeeker;

      x.title = `Work Order Rev - ${x.refId} - ${x.workerName} - ${x.mainDocumentTitle}`;

      //formart date to year-month-day
      let parts = x.startDate.split("/"); // 07/10/2023
      x.assignedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
      x.updatedDateTime = updatedTimeFinal;
      x.systemName = "fieldglass";
      x.description = `Site: ${x.site}, Unit: ${x.businessUnit}, Amount: ${x.amount}`;
      //x.link =  x.link;
      x.link = "https://intusurg.okta.com/home/intuitivesurgical_grifieldglass_1/0oa1feixuwrC0C4tN1d8/aln1fej18ev0lHBlB1d8"; //prod link
      //x.link = "https://xuat.fgvms.com/work_order_detail.do?id=z23092715584684443872903&ticc=ISI";
      //console.log("Final FG Work Order Revision: ", x)
      curApprovals.push(x);
    }
  }
  //end Fieldglass 

  //loop through SmartRecruiters
  key_counter = 1;
  for (let x of curSmartrecruitersData) {
    x.id = x.id + key_counter; //make id unique just incase
    key_counter++;
    x.description = `${x.title} - Created by: ${x.createdBy}`;
    x.title = `${x.approvalType} - ${x.refNumber}`

    x.approvalRequester = x.createdBy;

    x.assignedDate = x.createdDate.substring(0, 10); //2023-03-17T16:18:43.433Z
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "smartrecruiters";

    //x.link = x.reportLink; 
    x.link = "https://intusurg.okta.com/home/smartrecruiterssaml/0oa1jet5kjjjbeXxd1d8/54253";
    curApprovals.push(x);
  }

  //loop My HCM
  key_counter = 1;
  for (let x of curMyHcmData) {
    x.id = "My HCM" + x.id + key_counter; //make id unique just incase
    key_counter++;
    x.description = `Created by: ${x.createdBy}`;
    x.title = `${x.title}`

    x.approvalRequester = x.createdBy;

    x.assignedDate = x.assignedDate.substring(0, 10); //2023-03-17T16:18:43.433Z
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "my hcm";

    //x.link = x.reportLink; 
    x.link = "https://intusurg.okta.com/home/intuitivesurgical_oraclehcm_1/0oa1dz9bryiTBtpMN1d8/aln1dz9evhjhoMPSd1d8";
    curApprovals.push(x);
  }

  //loop MES
  key_counter = 1;
  for (let x of curMesData) {
    x.id = "MES" + x.qnNumber + key_counter; //make id unique just incase
    key_counter++;
    x.description = `Task Description: ${x.taskDescription}`;
    x.title = `QN Number: ${x.qnNumber} - Requested By: ${x.taskCreatedBy}`

    x.approvalRequester = x.taskCreatedBy;

    x.assignedDate = x.taskCreatedOn.substring(0, 10); //2023-03-17T16:18:43.433Z
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "mes";

    //x.link = x.reportLink; 
    x.link = "https://prd.intusurg.com/sap/bc/gui/sap/its/webgui";
    curApprovals.push(x);
  }


  //{
  //     "id": "CBJCHBCAABAAlSmJbJlwlW2lLDuattynfagWqOLgCMft",
  //     "type": "AGREEMENT",
  //     "name": "Test agreement - svc-anywhere to Beto & Luke",
  //     "displayDate": "2023-12-07T11:23:52Z",
  //     "requestorName": "SVC ISI Anywhere",
  //     "status": "WAITING_FOR_MY_SIGNATURE"
  // }
  //loop Adobe Sign
  key_counter = 1;
  for (let x of curAdobeSignData) {
    x.id = "AdobeSign" + x.id + key_counter; //make id unique just incase
    key_counter++;
    x.description = `Requested By: ${x.requestorName} - Status: ${x.status}`;
    x.title = `${x.name}`

    x.approvalRequester = x.requestorName;

    x.assignedDate = x.displayDate.substring(0, 10); //2023-12-07T11:23:52Z
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "adobe sign";

    //x.link = x.reportLink; 
    x.link = "https://intusurg.na1.echosign.com/";
    curApprovals.push(x);
  }

  //loop Archibus data
  // key_counter = 1;
  //   [
  //     {
  //         "createdDate": "2024-10-22",
  //         "recordsCount": 3,
  //         "email": "Beto.HernandezAdame@intusurg.com",
  //         "eM_ID": "BETO HERNANDEZ ADAME-658"
  //     }
  // ]

  key_counter = 1;
  for (let x of curArchibusData) {
    x.id = "Archibus" + key_counter;
    key_counter++;
    x.description = `Approver Email: ${x.email}`;
    x.title = "";
    x.approvalRequester = "";
    x.assignedDate = x.createdDate; // 2024-10-24
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "archibus moves";

    //x.link = x.reportLink; 
    x.link = "https://intuitivewpt.asset-fm.com/archibus/schema/ad-mo-approve-individual.axvw";
    curApprovals.push(x);
  }

  key_counter = 1;
  //SAP Workflow Purchas Order
  if (curSapWfData.purchaseOrder.length > 0) {
    for (let x of curSapWfData.purchaseOrder) {
      x.id = "SAP PO" + x.taskId + key_counter;
      key_counter++;
      x.title = `${x.description}`;
      x.description = "";
      x.approvalRequester = `Doc #: ${x.docNumber}`;
      //x.assignedDate = x.createdOn; // "20241203 => 2024-12-03
      let year = x.createdOn.substring(0, 4);
      let month = x.createdOn.substring(4, 6);
      let day = x.createdOn.substring(6, 8);
      x.assignedDate = `${year}-${month}-${day}`;;

      x.updatedDateTime = new Date();
      let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
      updatedTimeTmp = updatedTimeTmp.toString();
      x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
      x.systemName = "purchase order";

      //x.link = x.reportLink; 
      x.link = x.link;
      //https://prd.intusurg.com/sap/bc/ui2/flp?sap-client=800&sap-language=EN#Shell-home
      curApprovals.push(x);
    }
  }

  key_counter = 1;
  //SAP Workflow Change Record << new code section
  if (curSapWfData.changeRecord.length > 0) {
    for (let x of curSapWfData.changeRecord) {
      x.id = "Change Record" + x.taskId + key_counter;
      key_counter++;
      x.title = `${x.description}`;
      x.description = "";
      x.approvalRequester = `Doc #: ${x.docNumber}`;
      //x.assignedDate = x.createdOn; // "20241203 => 2024-12-03
      let year = x.createdOn.substring(0, 4);
      let month = x.createdOn.substring(4, 6);
      let day = x.createdOn.substring(6, 8);
      x.assignedDate = `${year}-${month}-${day}`;;

      x.updatedDateTime = new Date();
      let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
      updatedTimeTmp = updatedTimeTmp.toString();
      x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
      x.systemName = "change record";

      //x.link = x.reportLink; 
      x.link = x.link;
      //https://prd.intusurg.com/sap/bc/ui2/flp?sap-client=800&sap-language=EN#Shell-home
      curApprovals.push(x);
    }
  }

  // {
  //   "id": "4bd1989974d5900123e161b68b9d0000",
  //   "requestor": "David Adame",
  //   "approversEmail": "THOMAS.SHAW@INTUSURG.COM",
  //   "approvers": "Thomas Shaw",
  //   "processType": "Home Contact Change",
  //   "processEventDetail": "Notify Thomas Shaw of A To-Do Awaits you:  Initiate Location Change",
  //   "createdDate": "2024-08-20",
  //   "status": "Awaiting Action"
  // }
  //WorkDay

  key_counter = 1;
  for (let x of curWorkdayData) {
    x.id = "Workday" + x.id + key_counter;
    key_counter++;

    if (x.description == null) {
      x.description = ``;
    }
    else {
      x.description = `Requested by: ${x.requestor}`;
    }
    x.title = `Approval type: ${x.processType}`;
    x.approvalRequester = `Requested by: ${x.requestor} `;
    x.assignedDate = x.createdDate; // 2024-08-20
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "workday";

    //x.link = x.reportLink; 
    x.link = "https://wd5.myworkday.com/isrg/d/home.htmld";
    curApprovals.push(x);
  }

  //NEW UPDATES TO WORKDAY DATA SHOWN, ONLY ALLOWED IN UAT FOR NOW DEC 9 2025
  // key_counter = 1;
  // for (let x of curWorkdayData) {
  //   x.id = "Workday" + x.id + key_counter;
  //   key_counter++;

  //   if (x.processEventDetail == null) {
  //     x.description = ``;
  //   }
  //   else {
  //     x.description = `Details: ${x.processEventDetail}`;
  //   }
  //   if (x.requestor == null) {
  //     x.title = `Approval Type: ${x.processType} -- Approver Email: ${x.approversEmail}`;
  //   } else {
  //     x.title = `Approval Type: ${x.processType} -- Requested by: ${x.requestor} - Approver Email: ${x.approversEmail}`;
  //   }
  //   //x.title = `Approval type: ${x.processType} - Requested by: ${x.requestor} - Approver Email: ${x.approversEmail}`;
  //   x.approvalRequester = `Requested by: ${x.requestor} `;
  //   x.assignedDate = x.createdDate; // 2024-08-20
  //   x.updatedDateTime = new Date(); // API doesn't currently have this
  //   let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
  //   updatedTimeTmp = updatedTimeTmp.toString();
  //   x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
  //   x.systemName = "workday";

  //   //x.link = x.reportLink; 
  //   x.link = "https://wd5.myworkday.com/isrg/d/home.htmld";
  //   curApprovals.push(x);
  // }
  //NEW UPDATES TO WORKDAY DATA SHOWN, ONLY ALLOWED IN UAT FOR NOW DEC 9 2025

  //   {
  //     "requestor": "Eghbal, Darius",
  //     "employeeId": "514978",
  //     "timeOffType": "Flex Vacation",
  //     "timeOffDate": "2025-01-02T00:00:00",
  //     "startTime": "",
  //     "endTime": "",
  //     "value": 8.00,
  //     "unit": "Hours",
  //     "status": "Pending",
  //     "createdDate": "2024-12-10"
  // }

  key_counter = 1;
  for (let x of curWorkforceData) {
    x.id = "Workforce" + x.employeeId + key_counter;
    key_counter++;

    x.description = `${x.requestor} requests ${x.value} ${x.unit}`;
    x.title = `Time off type: ${x.timeOffType}`;
    x.approvalRequester = `Requested by: ${x.requestor} `;
    x.assignedDate = x.createdDate; // 2024-08-20
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "workforce";

    //x.link = x.reportLink; 
    x.link = "https://isi.workforcehosting.com/workforce/Home.do?action=start";
    curApprovals.push(x);
  }

  key_counter = 1;
  for (let x of curArchibusMaintenanceData) {
    x.id = "Archibus Maint" + key_counter;
    key_counter++;
    x.description = `Approver Email: ${x.email}`;
    x.title = "";
    x.approvalRequester = "";
    x.assignedDate = x.createdDate; // 2024-10-24
    x.updatedDateTime = new Date(); // API doesn't currently have this
    let updatedTimeTmp = new Date(Date.parse(x.updatedDateTime));
    updatedTimeTmp = updatedTimeTmp.toString();
    x.updatedDateTime = updatedTimeTmp.replace(/GMT.*/g, "");
    x.systemName = "archibus maint.";

    //x.link = x.reportLink; 
    x.link = "https://intuitivewpt.asset-fm.com/archibus/schema/ab-bldgops-console.axvw";
    curApprovals.push(x);
  }




  myObj.approvals = curApprovals;
  //console.log("JUST FINISHED REFRESHING DATA");


  //console.log(myObj.curUserInfo.name);  // obj includes Okta user info
  //console.log(myObj.curUserInfo); 
  dispatch({ type: 'FETCH_COMPLETE' });
  dispatch({ type: 'FETCH_APPROVALS', payload: myObj });
};

//API Call for ISI Anywhere Stats
export const sendStats = (app, uid) => async dispatch => {
  // console.log("I am in action sendStats: ", app, uid);

  const body = {
    source: "web",
    app: app,
    uid: uid,
    refKey: "e62778492de242a4b66ec230c24baeee"
  };
  try {
    const response = await approvalApi.post("/UserAppStats/update", body);
    // console.log("SUCCESS sending Stats: ", response.data);
  } catch (err) {
    console.log("Calling Stats API error. ", err);
  }

  dispatch({ type: 'STATS_SENT', payload: app });
}



//API Call - Check if logged in user has Analytics access
export const checkAnalyticsAccessOld = (curToken) => async dispatch => {
  // console.log("I am in action checkAnalytiiccsAccess: ");

  let dataObj = {
    analyticsAccess: false
  };

  try {

    // Define the base URL and endpoint
    const baseUrl = 'https://anywhere.intusurg.com/api/Analytics/count';

    // Define headers
    const headers = {
      'Authorization': 'Bearer ' + curToken.accessToken,
    };

    // Define query parameters
    const params = {
      analyticsType: 'ActivityCount',
      platform: 'desktop',
      startDate: '2023-12-01',
      endDate: '2023-12-19'
    };

    // Make GET request 
    const response = await axios.get(baseUrl, {
      headers: headers,
      params: params
    });

    dataObj.analyticsAccess = true;
    // console.log("User has Analytics access:", response);
    dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
  } catch (error) {
    // Handle any errors
    //console.error('Error fetching data:', error);
    dataObj.analyticsAccess = false;
    console.log("User does NOT have Analytics access:");
    dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
  }
}

export const checkAnalyticsAccess = (curToken) => async dispatch => {
  // console.log("I am in NEW action checkAnalytiiccsAccess: ");

  let dataObj = {
    analyticsAccess: false
  };

  try {

    // Define headers
    const headers = {
      'Authorization': 'Bearer ' + curToken.accessToken,
    };

    // Make GET request 
    const response = await approvalApi.get('/user/profile', { headers: headers });

    dataObj.analyticsAccess = false;
    // console.log("API Response:", response.data);
    const userRoles = response.data.roles;
    //check if user has the analytics role access
    for (let i = 0; i < userRoles.length; i++) {
      if (userRoles[i] === "analytics") {
        dataObj.analyticsAccess = true; //user has access to analytics
        // console.log("user has analtyics access");
      }
    }
    dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
  } catch (error) {
    // Handle any errors
    dataObj.analyticsAccess = false;
    console.log("API error: User does NOT have Analytics access:");
    dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
  }
}